import React from 'react'

function FourthSection() {
  return (
   <section className="py-16">
     <div className="container px-4 pr-5 max-w-max">
       <div className="text-center mb-16">
         <h2 className="text-5xl font-bold mb-8 uppercase">Silabus</h2>
         <p className="text-xl px-8 text-gray-800 leading-relaxed indent-16 capitalize text-justify">
           Program ini dirancang untuk memberikan pengetahuan dan keterampilan komprehensif dalam bidang tata rambut, mulai dari dasar hingga teknik lanjutan. Peserta akan diajarkan oleh instruktur berpengalaman yang akan membimbing mereka melalui teori dan praktik langsung. Serta dipastikan setelah menyelesaikan program ini dapat memahami dasar-dasar tata rambut dan kesehatan rambut, menguasai berbagai teknik gunting rambut, penataan rambut, dan teknik pewarnaan rambut, dan mampu memberikan konsultasi kepada pelanggan mengenai gaya rambut yang sesuai, serta memiliki pengetahuan tentang produk-produk perawatan rambut yang berkualitas.
         </p>
       </div>
     </div>
   </section>
  )
}

export default FourthSection